import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetWayWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {Timeline, TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {GGReelSymbol} from "../../symbols/GGReelSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";

export class GGIndividualWPController extends BetWayWinIndividualWPController {

    private _brokeTheBank:boolean;
    private _allWinPositions:boolean[][];

    constructor(config:IIndividualWinPresentationConfig) {
        super(config);
        EventHandler.addEventListener(this, "STATING_BONUS_FROM_AS", () => {
            this.stopWinPresentation(true);
        })
    }

    protected parseFeatureGameData(data:GGParsedGameData) {
        this._brokeTheBank = data.brokeBank;
        this._allWinPositions = ArrayHelper.initArrayWithValues(6, () => [false, false, false, false,false, false, false, false]);
        (<IBetWayWinData[]>this._betWinsData!).forEach((singleBetWayWinData:IBetWayWinData, index:number) => {
            singleBetWayWinData.reelWinPositions.forEach((reelWinPositions:boolean[], reelId:number) => {
                reelWinPositions.forEach((symbolWin:boolean, symId:number) => {
                    if(symbolWin) {
                        this._allWinPositions[reelId][symId] = true;
                    }
                });
            });
        });
    }

    protected getLineAnimation(betWayWinData:IBetWayWinData):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();

        if(this._betWinsData!.length > 1) {
            timeline.add(super.getLineAnimation(betWayWinData), 0.2);
            timeline.add(() => {}, "+=0.6");


        } else {
            timeline.add(this.createTotalLinesAnimation());
            timeline.add(() => {}, "+=0.6");
        }
        return timeline;
    }

    private createTotalLinesAnimation():TimelineLite {
        const totalWinTimeline = new TimelineLite();
        this._allWinPositions.forEach((reelWins:boolean[], reelId:number) => {
            reelWins.forEach((symbolWin, symId) => {
                if(symbolWin) {
                    const symbol = Reels.getSymbol(reelId, symId);
                    if(symbol) {
                        this.addSymbolWinAnimationToTimeline(null, totalWinTimeline, 0, symbol, reelId, symId);
                        if(this._winSymbols.indexOf(symbol) === -1) {
                            this._winSymbols.push(symbol);
                        }
                    }
                }
            });
        });

        return totalWinTimeline;
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData | null, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        timeline.add((<GGReelSymbol>symbol).playWinAnimation(), startTime);
    }

    protected startWinPresentation():void {
        if(!this._brokeTheBank) {
            this.abort();
            return;
        }
        super.startWinPresentation();
    }

    protected resetWinSymbols(isStop:boolean):void {
        if(!isStop) {
            return;
        }
        this._winSymbols = [];
    }
}